import IEmail from "@/module/main/dto/financing-v3/IEmail";

export class Email implements IEmail
{
    constructor(public value: string)
    {
    }
}
